module.exports = __webpack_public_path__ + "img/dh1.31657ad6.png";